package co.maytes.standupbot.dashboard.components.motion

import androidx.compose.runtime.Composable
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div

private const val CONTENT_SWAP_CLASS = "sb-content-swap"

const val STATE_SWAP_CLASS = "sb-state-swap"
private const val STATE_FADE_CLASS = "sb-enter-fade"

private class FirstPass(var value: Boolean = true)

private class SkeletonSeen(var value: Boolean = false)

@Composable
fun ContentSwap(
    ready: Boolean,
    skeleton: @Composable () -> Unit,
    modifier: Modifier = Modifier.fillMaxWidth(),
    content: @Composable () -> Unit,
) {
    val skeletonSeen = remember { SkeletonSeen() }
    if (!ready) skeletonSeen.value = true

    if (ready) {
        Div(attrs = (if (skeletonSeen.value) modifier.classNames(CONTENT_SWAP_CLASS) else modifier).toAttrs()) {
            content()
        }
    } else {
        skeleton()
    }
}

@Composable
fun StateSwap(
    state: Any?,
    rise: Boolean = true,
    modifier: Modifier = Modifier.fillMaxWidth(),
    content: @Composable () -> Unit,
) {
    val firstPass = remember { FirstPass() }
    val animate = !firstPass.value
    SideEffect { firstPass.value = false }
    key(state) {
        Div(attrs = (if (animate) modifier.classNames(if (rise) STATE_SWAP_CLASS else STATE_FADE_CLASS) else modifier).toAttrs()) {
            content()
        }
    }
}
